import { render, staticRenderFns } from "./CommonPageDialog.vue?vue&type=template&id=c2d9500a&scoped=true"
import script from "./CommonPageDialog.vue?vue&type=script&lang=js"
export * from "./CommonPageDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonPageDialog.vue?vue&type=style&index=0&id=c2d9500a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d9500a",
  null
  
)

export default component.exports